import { render, staticRenderFns } from "./detail-setup.vue?vue&type=template&id=aee3904a&scoped=true&"
import script from "./detail-setup.vue?vue&type=script&lang=js&"
export * from "./detail-setup.vue?vue&type=script&lang=js&"
import style0 from "./detail-setup.vue?vue&type=style&index=0&id=aee3904a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee3904a",
  null
  
)

export default component.exports